import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = {
  key: 0,
  "class": "text-box"
};
var _hoisted_2 = ["src"];
import { watchEffect, ref } from "../../../../adapter-vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'message-text',
  props: {
    content: {
      type: Object,
      "default": function _default() {
        return {};
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var data = ref();
    watchEffect(function () {
      data.value = props.content;
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).text, function (item, index) {
        return _openBlock(), _createElementBlock("span", {
          key: index
        }, [item.name === 'text' ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(item.text), 1)) : (_openBlock(), _createElementBlock("img", {
          key: 1,
          "class": "text-img",
          src: item.src
        }, null, 8, _hoisted_2))]);
      }), 128))]);
    };
  }
});